import { h, Component } from 'preact';
import { connect } from 'unistore/preact';
import { onChange } from '../../common/actions';
import CONSTANTS, { CACHE, UPI_INTENT_MWEB } from '../../utils/constants';
import { getKey, staticPath, clientMessage, equalsIgnoreCase } from '../../utils/common';
import { openPopUpWindow } from '../../utils/formPost';
import { PAYMODE } from '../../../../common/src/constant';
import { EVENT, log } from '../../common/logger';
import Renewal from '../subscription/renewal';
import UpiIntent from '../upi-intent';
import { locale } from '../../utils/i18n';
import PaymodeOffer from '../offers/paymodeOffer';
import { vpaValid, verifyVPA, proceedToCollectFlow } from '../../controllers/upi';
import UpiPolling from '../upipolling';

const _INVALID_UPI_CHAR_REGEX = /[^0-9a-z@A-Z.-]/g;
const _NEXT_AT_SYMBOL_REGEX = /(.*@.*)@/;

class Upi extends Component {
  constructor(props) {
    super(props);

    /* the handlers and relevant images related to JIRA - PGPUI-1001 */
    this.hanlders = [
      { imageUrl: `${staticPath()}/assets/images/ic-paytm.svg`, name: '@paytm' },
      { imageUrl: `${staticPath()}/assets/images/ic-upi.svg`, name: '@upi' },
      { imageUrl: `${staticPath()}/assets/images/ic-phonepe.svg`, name: '@ybl' },
      { imageUrl: `${staticPath()}/assets/images/ic-gpay.svg`, name: '@okicici' },
      { imageUrl: `${staticPath()}/assets/images/ic-gpay.svg`, name: '@okhdfcbank' },
      { imageUrl: `${staticPath()}/assets/images/ic-gpay.svg`, name: '@oksbi' }
    ];
    const locale = clientMessage(PAYMODE.UPI.toLowerCase(), this.props.cache);
    this.label = locale.label;
    this.error = locale.error;
    const isUpiIntentMwebEnabled =
      props.upiIntentApps.length === 0 &&
      getKey(this.props, 'channels.intentEnabled') &&
      this.props.cache.getData(UPI_INTENT_MWEB.IS_UPI_INTENT_MWEB_ENABLED);
    this.state = {
      upiIntentApps: this.props.upiIntentApps,
      selectedUpiIntentApp: {},
      showRemainingApps: false,
      showError: false,
      errorText: '',
      paymode: isUpiIntentMwebEnabled ? UPI_INTENT_MWEB.UPI_INTENT_MWEB : CONSTANTS.UPI,
      handlers: this.hanlders,
      errorObjMsg: {
        validErrorMsg: this.error.inValidId,
        requiredErrorMsg: this.error.required
      },
      isUpiIntentMwebEnabled,
      isUpiPollingRequired: false,
      pollingData: {}
    };
    this.upiIntentRef = null;
    this.onUpiPaymodeChannelClickUPI = this.onUpiPaymodeChannelClick.bind(this, CONSTANTS.UPI);
    this.onUpiPaymodeChannelClickMWEB = this.onUpiPaymodeChannelClick.bind(
      this,
      UPI_INTENT_MWEB.UPI_INTENT_MWEB
    );
  }

  componentDidMount() {
    // this.props.onPayChange(false);
    if (this.props.upiIntentApps.length > 0) {
      this.selectIntentApp(this.props.upiIntentApps[0]);
    }
  }

  componentDidUpdate(previousProps, prevState) {
    const selectedType = getKey(this.props, 'selected.type', null);

    if (
      selectedType &&
      equalsIgnoreCase(selectedType, PAYMODE.UPI) &&
      this.props.selected !== previousProps.selected
    ) {
      this.setState({
        upi: '',
        paymode: this.state.isUpiIntentMwebEnabled ? UPI_INTENT_MWEB.UPI_INTENT_MWEB : CONSTANTS.UPI
      });
      if (this.state.paymode === CONSTANTS.UPI) {
        // setTimeout(() => {
        //   this.focusOnUPI();
        // }, 100);
      }
    }
    if (
      getKey(prevState, 'isUpiPollingRequired', false) === true &&
      getKey(previousProps, 'isPollingRequired', false) === true &&
      getKey(this.props, 'isPollingRequired', true) === false
    ) {
      this.setState({ pollingData: {}, isUpiPollingRequired: false });
    }
  }

  submit = () => {
    if (this.state.paymode === CONSTANTS.UPI) {
      this.collectFlow();
    } else if (this.state.paymode === CONSTANTS.UPI_INTENT) {
      this.intentFlow();
    } else if (
      this.state.paymode === UPI_INTENT_MWEB.UPI_INTENT_MWEB &&
      this.upiIntentRef &&
      this.upiIntentRef._component
    ) {
      this.upiIntentRef._component.onSubmit();
    }
  };

  intentFlow = () => {};

  collectFlow = () => {
    // remove the handlers dropdown
    this.setState({ showHandlers: false });

    if (!this.state.upi) {
      this.setState(prevState => ({
        errorText: prevState.errorObjMsg.requiredErrorMsg,
        showError: true
      }));
      return;
    }

    if (!vpaValid(this.state.upi)) {
      this.setState(prevState => ({
        errorText: prevState.errorObjMsg.validErrorMsg,
        showError: true
      }));
      return;
    }

    log({ eventType: EVENT.COLLECT_FLOW_USED });
    this.props.cache.setData(CONSTANTS.IS_BANKPAGE_REQUIRED_BLOCKED, true);
    this.props.cache.getData(CACHE.STORE).setState({ overlayValue: CONSTANTS.PROCESSING });
    openPopUpWindow(this.props.cache);
    const payload = {
      authMode: CONSTANTS['3D'],
      payerAccount: this.state.upi,
      paymentMode: CONSTANTS.UPI,
      selectedPaymentModeId: this.props.option.id
    };
    if (getKey(this.props.subscription, 'isEnabled', false)) {
      verifyVPA(this.state.upi, this.props.cache)
        .then(res => {
          if (res.valid) {
            proceedToCollectFlow(payload, this.props.cache, this.state.upi)
              .then(res => {
                // postInWindow(res, this.props.cache)
                this.setState(res);
              })
              .catch(err => {
                this.setState(err);
              });
          }
        })
        .catch(error => {
          this.props.cache.getData(CACHE.STORE).setState({ overlayValue: '' });
          this.setState({ showError: true, errorText: error });
          // postInWindow({}, this.props.cache);
        });
    } else {
      proceedToCollectFlow(payload, this.props.cache, this.state.upi)
        .then(res => this.setState(res))
        .catch(err => {
          this.setState(err);
        });
    }
  };

  selectIntentApp = app => {
    this.setState({
      selectedUpiIntentApp: app,
      paymode: CONSTANTS.UPI_INTENT,
      genericErrorIntent: '',
      upi: '',
      showHandlers: false
    });

    this.props.onPayChange(true);
  };

  renderIntentApps = (startIndex, endIndex) => {
    const apps = [];
    for (let i = startIndex; i <= endIndex; i += 1) {
      apps.push(
        <div
          className={`ptm-upi-list-item`}
          onClick={() => this.selectIntentApp(this.state.upiIntentApps[i])}
        >
          <div
            className={`ptm-upi-img ${
              this.state.selectedUpiIntentApp.name === this.state.upiIntentApps[i].name
                ? 'ptm-activebank'
                : ''
            }`}
          >
            <img src={`${staticPath()}/assets/images/ic-upi.svg`} alt="" className="ptm-margin0" />
            {this.state.selectedUpiIntentApp.name === this.state.upiIntentApps[i].name ? (
              <div className="ptm-tick ptm-pos-a">
                <span className="ptm-sign1" />
                <span className="ptm-sign2" />
              </div>
            ) : null}
          </div>
          <p className={`ptm-bank-name`}>{this.state.upiIntentApps[i].displayName}</p>
        </div>
      );
    }
    if (this.state.upiIntentApps.length > 5 && !this.state.showRemainingApps) {
      apps.push(
        <div className={`ptm-upi-list-item`} onClick={() => this.toggleShowRemainingApps(true)}>
          <div className={`ptm-upi-img`}>
            <img
              src={`${staticPath()}/assets/images/ic-upi.svg`}
              alt=""
              className={`ptm-margin0`}
            />
          </div>
          <p className={`ptm-bank-name`}>More</p>
        </div>
      );
    }

    return apps;
  };

  handleInputClick = paymode => {
    this.setState({ paymode, selectedUpiIntentApp: '' });
  };

  handlePastedInput = () => {
    const upiFld = this.upi;
    setTimeout(() => {
      this.applyPromoOnVPAValidate(upiFld.value);
      this.setState({ upi: upiFld.value, paymode: CONSTANTS.UPI, selectedUpiIntentApp: '' }); // setting state values same as input focus
    }, 100);
  };

  // isVpaValid(ev) {
  //   if (this.state.upi !== this.upi.value) {
  //     this.setState({ upi: this.upi.value });
  //   }
  //   const isValid = this.vpaValid(this.state.upi);
  //   if (isValid) {
  //     this.verifyVPA();
  //   } else {
  //     this.setState({ showError: true, errorText: 'Enter Valid UPI Id' });
  //   }
  // }

  updateUpiId(_ev) {
    const ev = _ev;
    ev.target.value = ev.target.value
      .replace(_INVALID_UPI_CHAR_REGEX, '')
      .replace(_NEXT_AT_SYMBOL_REGEX, '$1');
    const upi = ev.target.value;

    let showHandlers = false;

    if (upi.split('@').length > 1) {
      showHandlers = true;
      this.applyPromoOnVPAValidate(upi);
    }
    this.setState({
      upi,
      showError: false,
      errorText: '',
      vpaVerified: false,
      btnDisabled: false,
      showHandlers
    });
  }

  applyPromoOnVPAValidate(vpa) {
    if (!this.props.isPromoAvailable) {
      return;
    }

    if (!vpaValid(vpa)) {
      this.props.applyPromoForPayMode(this.props.option);
      return;
    }

    this.props.onPayChange(false);

    verifyVPA(vpa, this.props.cache)
      .then(response => {
        if (response.valid) {
          this.props.applyPromoForPayMode(this.props.option, null, null, vpa);
        } else {
          this.props.applyPromoForPayMode(this.props.option);
        }
      })
      .catch(() => {
        this.props.applyPromoForPayMode(this.props.option);
        this.props.onPayChange(true);
      });
  }

  toggleShowRemainingApps = value => {
    this.setState({ showRemainingApps: value, showError: true });
  };

  updateUpiWithHandler = handler => {
    log({ eventType: EVENT.UPI_HANDLER_SELECTED, handler });
    const upi = this.state.upi.split('@')[0] + handler;
    this.setState({
      ...this.state,
      upi,
      showHandlers: false
    });
    this.props.onPayChange(true);
    this.applyPromoOnVPAValidate(upi);
  };

  renderHandlerSuggestions = () => {
    const handlerName = this.state.upi ? this.state.upi.split('@')[1] : '';
    log({ eventType: EVENT.DISPLAY_UPI_HANDLER_SUGGESTION });
    const suggestions = [];
    this.state.handlers.forEach(handler => {
      /* if the upi handle is found in suggestion then only show relevant handles and not all handlers */
      if (handler.name.indexOf(handlerName.toLowerCase()) > -1) {
        suggestions.push(
          <div
            className={`ptm-suggest-card ptm-global-border`}
            onClick={() => this.updateUpiWithHandler(handler.name)}
          >
            <div className={`ptm-suggest-card-box ptm-pos-r ptm-body-color`}>
              <img src={handler.imageUrl} alt="bank" className={`ptm-margin0`} />
              {handler.name}
            </div>
          </div>
        );
      }
    });
    return suggestions;
  };

  onOptionSelect = option => {
    this.props.onOptionSelect(option);
    try {
      if (!this.state.isUpiIntentMwebEnabled) {
        // setTimeout(() => {
        //   this.focusOnUPI();
        // }, 100);

        log({ eventType: EVENT.UPI_FOCUS });
      }
    } catch (error) {
      log({ eventType: EVENT.UPI_FOCUS_ERROR, error });
    }
  };

  // focusOnUPI = () => {
  //   !isIphoneDevice() && isMobileDevice() && this.upi && this.upi.focus();
  // };

  onUpiPaymodeChannelClick = value => {
    this.setState({ paymode: value });
    /* if value is upi ie collect box then focus on it and open keyboard */
    // if (value === CONSTANTS.UPI) {
    //   setTimeout(() => {
    //     this.focusOnUPI();
    //     const element = document.querySelector('.ptm-upi-select');
    //     const defaultSelectedPaymodeOffSetTop = getKey(element, 'offsetTop', 0);
    //     scrollWithTimeout(defaultSelectedPaymodeOffSetTop - 60);
    //   }, 100);
    // }

    log({ eventType: EVENT.BUTTON_CLICK, value });
  };

  render(
    { option, instanceKey, channels, isActive, offers },
    {
      upiIntentApps,
      upi,
      paymode,
      showError,
      errorText,
      showHandlers,
      isUpiIntentMwebEnabled,
      isUpiPollingRequired,
      pollingData
    }
  ) {
    const { collectEnabled, intentEnabled } = channels;

    if (!collectEnabled && !isUpiIntentMwebEnabled) {
      return '';
    }
    const upiOffer = getKey(offers, PAYMODE.UPI);

    return (
      <div
        className={`ptm-bhipupi-main ${isUpiPollingRequired ? 'ptm-upipolling-stretched' : ''}`}
        ref={componentRef => {
          this.componentRef = componentRef;
        }}
      >
        <div class={`ptm-pay-method ptm-w100-ib ptm-noborder`} id="checkout-upi">
          <div
            class={`ptm-radio-wrap ptm-pt11`}
            onClick={() => {
              this.onOptionSelect(option);
            }}
          >
            <label class="ptm-lbl">
              <input
                type="radio"
                name={`verify${instanceKey}`}
                checked={isActive}
                className={`ptm-margin0`}
              />
              <span class="ptm-checkmark" />
              <div class={`ptm-pay-method-cont`}>
                <p class={`ptm-paymode-name`}>
                  {!collectEnabled && isUpiIntentMwebEnabled
                    ? locale('upi_intent.paymode.label')
                    : option.displayName}
                </p>
              </div>
            </label>
          </div>
          {/* UPI inner */}
          {option && isActive && (
            <div className={`ptm-upi-inner`}>
              {/* {intentEnabled && ( */}
              {/*  <div> */}
              {/*    <h4 className={`${style['upi-select']} ptm-uppercase`}>{this.label.selectUpi}</h4> */}
              {/*    <div className={`${style['upi-list']} ptm-w100-ib`}> */}
              {/*      {!showRemainingApps && */}
              {/*        this.renderIntentApps( */}
              {/*          0, */}
              {/*          upiIntentApps.length === 5 */}
              {/*            ? 4 */}
              {/*            : upiIntentApps.length < 5 */}
              {/*            ? upiIntentApps.length - 1 */}
              {/*            : 3 */}
              {/*        )} */}
              {/*      {showRemainingApps && this.renderIntentApps(0, upiIntentApps.length - 1)} */}
              {/*    </div> */}
              {/*  </div> */}
              {/* )} */}
              {isUpiIntentMwebEnabled && (
                <UpiIntent
                  ref={r => {
                    this.upiIntentRef = r;
                  }}
                  onIntentClick={this.onUpiPaymodeChannelClickMWEB}
                  paymode={paymode}
                  option={option}
                />
              )}
              {collectEnabled && isUpiIntentMwebEnabled && (
                <div className={`ptm-ortxt-box ptm-pos-r `}>
                  <div className={`ptm-or-line ptm-global-border`} />
                  <span className={`ptm-ortxt ptm-body-bg ptm-body-color ptm-pos-a`}>OR</span>
                </div>
              )}

              {collectEnabled && (
                <div
                  className={`ptm-upi-main-box ptm-pos-r`}
                  onClick={this.onUpiPaymodeChannelClickUPI}
                >
                  <div className={`ptm-upi-icon ptm-pos-a`}>
                    <img
                      className={`ptm-upi-icon-pic ptm-centralized`}
                      src={`${staticPath()}/assets/images/paybyupi.png`}
                      alt="logos"
                    />
                    {paymode === CONSTANTS.UPI && (
                      <div className={`ptm-tick ptm-pos-a`}>
                        <span className={`ptm-sign1`} />
                        <span className={`ptm-sign2`} />
                      </div>
                    )}
                  </div>
                  <div className={`ptm-upi-heading-txt ptm-body-color`}>{locale('upi.title')}</div>
                  <div className={`ptm-upi-sbtxt ptm-body-color`}>{locale('upi.title.desc')}</div>
                </div>
              )}
              {collectEnabled && (
                <div className={`ptm-upi-select`} onClick={this.onUpiPaymodeChannelClickUPI}>
                  {intentEnabled && upiIntentApps && upiIntentApps.length > 0 && (
                    <h4 className={`ptm-upi-select ptm-uppercase`}>{this.label.UpiEnterSuggest}</h4>
                  )}
                  <div className={`ptm-pos-r ptm-bhim-upi-wrap`}>
                    <div>
                      <input
                        type="text"
                        placeholder="username@bank"
                        className={`ptm-margin0 ptm-upi-input`}
                        value={paymode === CONSTANTS.UPI ? upi : ''}
                        ref={p => {
                          this.upi = p;
                        }}
                        // autoFocus={!isIphoneDevice()}
                        id="ptm-upi-input"
                        onKeyUp={e => this.updateUpiId(e)}
                        onClick={() => this.handleInputClick(CONSTANTS.UPI)}
                        onPaste={e => {
                          this.handlePastedInput(e);
                        }}
                      />
                      {showError ? <p className={`ptm-msg-red`}>{errorText}</p> : null}
                      {upiOffer && <PaymodeOffer offer={upiOffer} noLeftPadding={true} />}
                    </div>
                    <div className={`paytm-txt-center ptm-sugg-wrap ptm-handlers-wrap`}>
                      {showHandlers && this.renderHandlerSuggestions()}
                    </div>
                  </div>
                </div>
              )}
              <Renewal />
            </div>
          )}
          <p className={`ptm-global-bottom-border`} />
          {isUpiPollingRequired && pollingData && pollingData.vpaID && (
            <UpiPolling pollingData={pollingData} />
          )}
        </div>
      </div>
    );
  }
}

export default connect(
  'selected, style, cache, instanceKey, subscription, isPollingRequired',
  onChange
)(Upi);



// WEBPACK FOOTER //
// ./components/upi/index.js